/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { APIErrorSchema } from "./APIErrorSchema.ts"
import { protectedProfileSchema } from "./protectedProfileSchema.ts"
import { z } from "zod/v4"

/**
 * @description Successfully fetched your profile
 */
export const getYourProfile200Schema = protectedProfileSchema

/**
 * @description The \"Authorization\" header does not contain a valid Bearer access token.
 */
export const getYourProfile401Schema = APIErrorSchema

export const getYourProfileQueryResponseSchema = getYourProfile200Schema
